import { useState } from 'react';
import { Container, Typography, Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Grid, Card, CardContent, IconButton, MenuItem } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { loadData, saveData, uid } from '../store/data';
import SectionHero from '../components/SectionHero';
import { motion } from 'framer-motion';

export default function Subcategories() {
  const [data, setData] = useState(loadData());
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ id: '', categoryId: '', name: '' });

  const openAdd = () => {
    setEditing(null);
    setForm({ id: '', categoryId: '', name: '' });
    setOpen(true);
  };
  const openEdit = (item) => {
    setEditing(item.id);
    setForm(item);
    setOpen(true);
  };
  const close = () => setOpen(false);

  const save = () => {
    let subcategories = data.subcategories || [];
    if (editing) {
      subcategories = subcategories.map((i) => (i.id === editing ? form : i));
    } else {
      subcategories = [...subcategories, { ...form, id: uid() }];
    }
    const next = { ...data, subcategories };
    saveData(next);
    setData(next);
    setOpen(false);
  };

  const remove = (id) => {
    const subcategories = (data.subcategories || []).filter((i) => i.id !== id);
    const products = (data.products || []).filter((p) => p.subcategoryId !== id);
    const next = { ...data, subcategories, products };
    saveData(next);
    setData(next);
  };

  const items = data.subcategories || [];
  const categories = data.categories || [];

  return (
    <>
      <SectionHero
        title="Subcategories"
        subtitle="Group products by aisle type, depth, and application"
        variant="grid"
      />
      <Container sx={{ py: { xs: 4, md: 6 }, px: { xs: 2, sm: 3 } }}>
        <Box sx={{ display: 'flex', justifyContent: { xs: 'stretch', sm: 'flex-end' }, mb: 2 }}>
          <Button variant="contained" startIcon={<AddIcon />} onClick={openAdd} fullWidth sx={{ maxWidth: { sm: 'none' }, width: { xs: '100%', sm: 'auto' } }}>Add Subcategory</Button>
        </Box>
      <Grid container spacing={3} component={motion.div} initial="hidden" animate="show" variants={{ hidden: {}, show: { transition: { staggerChildren: 0.08 }}}}>
        {items.map((it) => (
          <Grid item xs={12} md={6} key={it.id} component={motion.div} variants={{ hidden: { opacity: 0, y: 16 }, show: { opacity: 1, y: 0 }}}>
            <Card component={motion.div} whileHover={{ y: -4 }} transition={{ type: 'spring', stiffness: 300, damping: 22 }}>
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1, flexWrap: 'wrap' }}>
                  <Typography variant="h6" sx={{ fontWeight: 700, flex: 1, minWidth: 0, wordBreak: 'break-word' }}>{it.name}</Typography>
                  <Box>
                    <IconButton onClick={() => openEdit(it)}><EditIcon /></IconButton>
                    <IconButton onClick={() => remove(it.id)}><DeleteIcon /></IconButton>
                  </Box>
                </Box>
                <Typography sx={{ color: 'text.secondary', mt: 1 }}>
                  Category: {categories.find(c => c.id === it.categoryId)?.name || '—'}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Dialog open={open} onClose={close} fullWidth maxWidth="sm">
        <DialogTitle>{editing ? 'Edit Subcategory' : 'Add Subcategory'}</DialogTitle>
        <DialogContent sx={{ display: 'grid', gap: 2 }}>
          <TextField
            select
            label="Category"
            value={form.categoryId}
            onChange={(e) => setForm({ ...form, categoryId: e.target.value })}
            fullWidth
          >
            {categories.map((c) => (
              <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
            ))}
          </TextField>
          <TextField label="Name" fullWidth value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        </DialogContent>
        <DialogActions>
          <Button onClick={close}>Cancel</Button>
          <Button variant="contained" onClick={save}>Save</Button>
        </DialogActions>
      </Dialog>
    </Container>
    </>
  );
}
